import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MetaTagService } from '@core/services/meta-tag.service';
import { Observable, of } from 'rxjs';
import { tap, first } from 'rxjs/operators';

import { DigitalCourse } from '../../models';
import { DigitalCourseStoreService } from './digital-course.store.service';

@Injectable()
export class DigitalCourseResolver implements Resolve<DigitalCourse> {
  constructor(
    private digitalCourseStoreService: DigitalCourseStoreService,
    private metaService: MetaTagService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DigitalCourse> {
    const courseId = route.params['id'];
    if (courseId) {
      return this.digitalCourseStoreService.getDigitalCourse(courseId).pipe(
        tap((course) => {
          if (!course) {
            this.digitalCourseStoreService.fetchDigitalCourse(courseId);
          } else {
            this.metaService.digitalCourseOGMetaTag(course);
          }
        }),
        first(course => course && Boolean(Object.keys(course).length > 0))
      );
    } else {
      return of(null);
    }
  }
}
